/**
 * Defines the columns
 * And any action against the columns
 */
export class LenderColumnsModel {
	private _columns: Array<any>;
	constructor() {
		this._columns = [
			{
				headerName: 'Acuity Branch Id',
				field: 'acuityId',
				width: 120,
				resizable: false
			},
			{
				headerName: 'Acuity Branch Name',
				field: 'acuityName',
				width: 120,
				resizable: false
			},
			{
				headerName: 'AppScope Client Id',
				field: 'scopeId',
				width: 120,
				resizable: false
			},
			{
				headerName: 'AppScope Client Name',
				field: 'scopeName',
				width: 120,
				resizable: false
			},
			{
				headerName: 'InsideMaps OrgId',
				field: 'insideMapsOrgId',
				width: 120,
				resizable: false
			},
			{
				headerName: 'Cmp Acuity Branch Id',
				field: 'cmpAcuityId',
				width: 120,
				resizable: false
			},
			{
				headerName: 'Cmp Acuity Branch Name',
				field: 'cmpAcuityName',
				width: 120,
				resizable: false
			},
			{
				headerName: 'Actions',
				width: 100,
				cellRenderer: 'customActionLenderCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
